import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IRotateSiteEncryptionDataKeyParams {}

export interface RotateSiteEncryptionDataKeyResult extends IResult {}

export class RotateSiteEncryptionDataKeyRequest extends Request<IRotateSiteEncryptionDataKeyParams, RotateSiteEncryptionDataKeyResult> {
  constructor(params: IRotateSiteEncryptionDataKeyParams) {
    super('rotateSiteEncryptionDataKey', params);
  }
}